import { render, staticRenderFns } from "./TestUserList.vue?vue&type=template&id=166be95c&scoped=true&"
import script from "./TestUserList.vue?vue&type=script&lang=js&"
export * from "./TestUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166be95c",
  null
  
)

export default component.exports